import { useTranslation } from 'react-i18next';

type Props = {
  cartTotalPrice?: string;
};

export const ReceiveCartFooter = ({ cartTotalPrice }: Props) => {
  const { t } = useTranslation();
  return (
    <div className='mx-auto flex w-full max-w-[1440px] flex-row items-center justify-end gap-2 self-end whitespace-nowrap px-8 py-6 md:px-10'>
      <span className='text-200'>{t('common.cart_total')}</span>
      <span className='heading-200'>{cartTotalPrice}</span>
    </div>
  );
};
